import { Observable } from 'rxjs';

import {
  Location$,
  LocationInfo,
  retrieveLocation,
} from '../cordovaPlugins/Location';
import { ServiceProps } from './Service';

interface LocationServiceProps {
  getLocation: () => Promise<LocationInfo>;
  lastLocation$: Observable<LocationInfo>;
}

export function LocationService(props: ServiceProps): LocationServiceProps {
  console.log('LocationService starting');

  function getLocation(): Promise<LocationInfo> {
    return props.permissions$
      .do((data) => console.debug('LocationService.getLocation', data))
      .switchMap((permissions) => {
        return retrieveLocation(permissions.location);
      })
      .catch((e) => {
        console.error('LocationService.getLocation as fallback', e);
        return retrieveLocation(null, true);
      })
      .toPromise();
  }

  props.permissions$.skip(1).subscribe(() => {
    // when permissions change get the location
    console.log('Getting location (permission change)');
    getLocation();
  });

  document.addEventListener('resume', () => {
    console.log('Getting location (document resume event)');
    getLocation();
  });

  const lastLocation$: Observable<LocationInfo> = Location$;

  console.log('LocationService started');

  return { lastLocation$, getLocation };
}
